<template>
    <div class="channel">      
      <div class="channel-bottom">
        <div class="jiegou-input">
          <span class="trend-title">华东区</span>
          <el-input type="number" placeholder="请输入" v-model="chanelData.eastNum">
            <template slot="suffix">家</template>
          </el-input>
        </div>
        <div class="jiegou-input">
          <span class="trend-title">华南区</span>
          <el-input type="number" placeholder="请输入" v-model="chanelData.southNum">
            <template slot="suffix">家</template>
          </el-input>
        </div>
        <div class="jiegou-input">
          <span class="trend-title">华西区</span>
          <el-input type="number" placeholder="请输入" v-model="chanelData.westNum">
            <template slot="suffix">家</template>
          </el-input>
        </div>
        <div class="jiegou-input">
          <span class="trend-title">华北区</span>
          <el-input type="number" placeholder="请输入" v-model="chanelData.northNum">
            <template slot="suffix">家</template>
          </el-input>
        </div>
        <div class="jiegou-input">
          <span class="trend-title">华中区</span>
          <el-input type="number" placeholder="请输入" v-model="chanelData.centralNum">
            <template slot="suffix">家</template>
          </el-input>
        </div>
      </div>
      <div class="last-save">
         <el-button :loading="channLoading" size="small" @click="saveChannel" type="primary">保存</el-button>
      </div>
    </div>
</template>

<script>
import api from '@/apis/sale/sale'
export default {
  data() {
    return {
      channLoading:false,//加载状态
      chanelData:{
        eastNum:'',//华东区
        southNum:'',//华南区
        westNum:'',//华西区
        northNum:'',//华北区
        centralNum:'',//华中区
      }
    }
  },
  mounted() {
    this.getChannel()
  },
  methods: {
    //保存数据
    saveChannel(){
      this.channLoading = true;
      api.saveChannel(this.chanelData).then(res=>{
        if(res.code==10000){
          this.$message.success('保存成功');
          this.channLoading = false;
        }else{
          this.$message.error(res.message);
          this.channLoading = false;
          return;
        }
      })
    },
    //获取数据
    getChannel(){
      api.getChannel().then(res=>{
        if(res.code==10000){
          if(res.data.list.length!=0){
            this.chanelData = res.data.list[0]
          }
        }
      })
    },
  }
}
</script>
<style lang="less" scoped>
.channel{ padding-top: 10px;
  .channel-bottom{
    .jiegou-input{ margin-bottom: 15px;
      .el-input{ width: 15rem;}
    }
  }
}
</style>
